<template>
  <div class="recommend-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.recommend') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.recommend') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="favorite"/>
      </div>
      <div class="page-right">
        <div class="card">
          <div class="content-title color-orange card-header">{{ $t('recommend.title') }}</div>
          <div class="content">
            <img :src="img" class="bg">
            <p>{{ $t('recommend.content1') }}</p>
            <p>{{ $t('recommend.content2') }}</p>
            <p>{{ $t('recommend.content3') }}</p>
            <p>{{ $t('recommend.content4') }}</p>
            <p>{{ $t('recommend.content5') }}</p>
            <p>{{ $t('recommend.content6') }}</p>
            <p>{{ $t('recommend.content7') }}</p>
          </div>
          <div class="content-title second-title">{{ $t('recommend.share_link') }}</div>
          <div class="content">
            <input type="text" readonly :value="recommend_url" id="recommend_url">
          </div>
        </div>
        <div class="share-btns">
          <div class="btn btn-green" @click="callWechatShare"><Icon type="wechat"></Icon>{{ $t('recommend.share_type_wechat') }}</div>
          <div class="btn btn-orange" @click="callEmail"><Icon type="mail"></Icon>{{ $t('recommend.share_type_email') }}</div>
          <div class="btn btn-black" @click="copyLink"><Icon type="link"></Icon>{{ $t('recommend.share_type_link') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
import img from './images/Group_359.png'
import { mapState } from 'vuex'
  export default {
    name: 'recommend',
    data() {
      return {
        img,
        recommend_url: '',
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    components: {
      userSideMenu
    },
    created() {
      const parent_id = this.userInfo.user.id;
      this.recommend_url = `${location.protocol}//${location.host}/#/register?type=login&parent_member_id=${parent_id}`;
    },
    methods: {
      callWechatShare() {

      },
      callEmail() {
        location.href=`mailto:?subject=偷偷告诉你一个好网站&body=这个网站的内衣非常好看%0A${this.recommend_url}`;
      },
      copyLink() {
        const input = document.querySelector('#recommend_url');
        input.select();
        if (document.execCommand('copy')) {
          document.execCommand('copy');
          console.log('复制成功');  
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.recommend-page {
  .page-container {
    @media (max-width: 992px) {
      padding-top: 0;
    }
  }
  .content-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: 400;
    @media (max-width: 992px) {
      text-align: center;
    }
  }
  .card-header {
    @media (max-width: 992px) {
      border-bottom: 1px solid #E6E6E6;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
    }
  }
  .second-title {
    @media (max-width: 992px) {
      font-size: 1rem;
      margin-top: 2rem;
      margin-bottom: .5rem;
    }
  } 
  .card {
    @media (max-width: 992px) {
      box-shadow: 0px 5px 6px 3px rgba(0, 0, 0, 0.2);
      padding: 20px;
      border-radius: 6px;
      padding: 20px;
      padding-bottom: 10px;
    }
  }
  .content {
    width: 85%;
    position: relative;
    margin-bottom: 50px;
    @media (max-width: 992px) {
      width: 100%;
      margin-bottom: 10px;
    }
    img {
      margin-left: 40px;
      position: absolute;
      right: 0;
      top: 40px;
      @media (max-width: 992px) {
        width: 45%;
        top: unset;
        bottom: -20px;
      }
    }
    p {
      margin-bottom: 0.5rem;
      @media (max-width: 992px) {
      text-align: center;
    }
    }
    input {
      width: 100%;
      @media (max-width: 992px) {
        margin-left: -10px;
        margin-right: -10px;
        width: calc(100% + 20px);
      }
    }
  }
  .share-btns {
    width: 85%;
    display: flex;
    margin-top: -20px;
    margin-bottom: 40px;
    @media (max-width: 992px) {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .btn {
      flex: 1;
      margin-right: 30px;
      padding: 2px;
      display: flex;
      align-items: center;
      letter-spacing: 3px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      @media (max-width: 992px) {
        border-radius: 10px;
        margin-right: 10px;
        padding: 6px;
      }
    }
    & /deep/ .cloud-icon {
      margin-right: 6px;
      fill: white;
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>